module.exports = __webpack_public_path__ + "assets/img/baigongfen_2(2).ab67dec2.jpg";